import styled from 'styled-components';

export const TitleBumper = styled.div`
  margin-bottom: 20px;
`;
